import { keyframes } from 'styled-components'

const slideInFromLeftAnimation = keyframes`
  0% {
      transform: translateX(-100%);
  }

  50% {
      transform: translateX(100%);
  }

  100% {
      transform: translateX(100%);
  }
`
export default slideInFromLeftAnimation
